var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import ReactDOM from "react-dom";
import { ErrorBoundary } from "../services/bugsnag";
import Payment from "./pages/PaymentPortal/Payment";
import { BrowserRouter, Switch } from "react-router-dom";
import { Route } from "react-router";
import Verify from "./pages/PaymentPortal/Verify";
import { ModalProvider } from "../contexts/ModalContext";
import ModalRoot from "./organisms/ModalRoot";
import LanguageRoot from "./organisms/LanguageRoot";
import { ThemeProvider } from "styled-components";
import { getAppTheme } from "../../services/appTheme";
const PaymentPortal = (_a) => {
    var props = __rest(_a, []);
    const appTheme = getAppTheme();
    return (React.createElement(ThemeProvider, { theme: appTheme },
        React.createElement(ErrorBoundary, null,
            React.createElement(BrowserRouter, null,
                React.createElement(ModalRoot, null),
                React.createElement(LanguageRoot, null),
                React.createElement(Switch, null,
                    React.createElement(Route, { exact: true, path: "/i/:dossier/:amount/betaling" },
                        React.createElement(Verify, Object.assign({}, props))),
                    React.createElement(Route, null,
                        React.createElement(Payment, Object.assign({}, props))))))));
};
export default PaymentPortal;
const element = document.getElementById("payment-portal");
const dossierNumber = element.dataset.dossiernumber;
const amountInCents = parseInt(element.dataset.amount) || null;
const debtorPortal = element.dataset.debtorPortal;
const simpleMode = element.dataset.simple === '1' ? true : false;
ReactDOM.render(React.createElement(ModalProvider, null,
    React.createElement(PaymentPortal, { amountInCents: amountInCents, dossierNumber: dossierNumber, debtorPortal: debtorPortal, simpleMode: simpleMode })), element);
